<template>
	<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
		<el-tab-pane label="Role Information" name="first">
			<el-row>
				<el-col :span="24">
					<el-form :inline="true" :model="filters" label-width="100px">
						<el-form-item label="RoleName">
							<el-input v-model="filters.sRoleName" placeholder=""></el-input>
						</el-form-item>
						<el-form-item label="Status">
							<el-select v-model="filters.sState" placeholder="">
								<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" v-on:click="reGetList()">Search</el-button>
							<el-button type="primary" v-on:click="addRoleFlag = true">
								Add Role
							</el-button>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="24">
					<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" @row-click="toDetailRole" style="width: 100%" @selection-change="handleSelectionChange">
						<el-table-column type="selection"></el-table-column>
						<el-table-column prop="sRoleName" label="Role Name"></el-table-column>
						<el-table-column prop="sRoleDescribe" label="Role Description"></el-table-column>
						<el-table-column prop="sState" label="Status" :formatter="sState"></el-table-column>
					</el-table>
				</el-col>
				<el-col :span="24">
					<div style="margin-top:20px;float: left;" v-if="tableData3.length > 0">
						<el-button @click="toggleSelection(0)" v-if="filters.sState == 1">
							Inactive
						</el-button>
						<el-button @click="toggleSelection(1)" v-if="filters.sState == 0">
							Active
						</el-button>
					</div>
					<div style="float: right;margin-top:20px;">
						<el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :total="total"></el-pagination>
					</div>
				</el-col>
			</el-row>
			<el-dialog title="Add Roles" :visible.sync="addRoleFlag" width="50%">
				<el-form :model="form" ref="form" label-width="100px">
					<el-form-item label="Role Name" prop="sRoleName">
						<el-input v-model="form.sRoleName" placeholder=""></el-input>
					</el-form-item>
					<el-form-item label="Authority">
						<el-checkbox-group v-model="form.roles">
							<el-checkbox v-for="a in options3" :label="a.name" :key="a.id">{{ a.name }}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="Role Describe" prop="sRoleDescribe">
						<el-input v-model="form.sRoleDescribe" type="textarea" placeholder=""></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="addRoleFlag = false">Cancel</el-button>
					<el-button type="primary" @click="save">Confirm</el-button>
				</span>
			</el-dialog>
			<el-dialog title="Edit Roles" :visible.sync="EditRoleFlag" width="50%">
				<el-form :model="detailForm" ref="detailForm" label-width="100px">
					<el-form-item label="Role Name" prop="sRoleName">
						<el-input v-model="detailForm.sRoleName" placeholder=""></el-input>
					</el-form-item>
					<el-form-item label="Authority">
						<el-checkbox-group v-model="detailForm.roles">
							<el-checkbox v-for="a in options3" :label="a.name" :key="a.id">{{ a.name }}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<el-form-item label="Role Describe" prop="sRoleDescribe">
						<el-input v-model="detailForm.sRoleDescribe" type="textarea" placeholder=""></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="EditRoleFlag = false">Cancel</el-button>
					<el-button type="primary" @click="saveEdit">Confirm</el-button>
				</span>
			</el-dialog>
		</el-tab-pane>
		<el-tab-pane label="User Related" name="second">
			<el-row>
				<el-col :span="24">
					<el-form :inline="true" :model="filters2" label-width="100px">
						<el-form-item label="Role">
							<el-select v-model="filters2.nRoleId" placeholder="Select">
								<el-option v-for="item in totalRoleList" :key="item.nRoleId" :label="item.sRoleName" :value="item.nRoleId"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" v-on:click="change2">Search</el-button>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="24">
					<el-transfer filterable :filter-method="filterMethod2" :titles="['Unselect', 'Select']" filter-placeholder="Name" v-model="filters2.nUserIds" :data="leftRoleList2"></el-transfer>
				</el-col>
				<el-col :span="24">
					<div style="margin-top:20px">
						<el-button @click="save2">Save</el-button>
					</div>
				</el-col>
			</el-row>
		</el-tab-pane>
		<el-tab-pane label="Data Source Related" name="third">
			<el-row>
				<el-col :span="24">
					<el-form :inline="true" :model="filters3" label-width="100px">
						<el-form-item label="Role">
							<el-select v-model="filters3.nRoleId" placeholder="Select">
								<el-option v-for="item in totalRoleList" :key="item.nRoleId" v-if="item.nRoleId != 1" :label="item.sRoleName" :value="item.nRoleId"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" v-on:click="change3">Search</el-button>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="24">
					<el-transfer filterable :filter-method="filterMethod3" :titles="['Unselect', 'Select']" filter-placeholder="Name" v-model="filters3.nSelectIds" :data="leftRoleList3"></el-transfer>
				</el-col>
				<el-col :span="24">
					<div style="margin-top:20px">
						<el-button @click="save3">Save</el-button>
					</div>
				</el-col>
			</el-row>
		</el-tab-pane>
		<el-tab-pane label="Table Management" name="fourth">
			<el-col :span="24">
				<el-form :inline="true" :model="filters4" label-width="100px">
					<el-form-item label="Role">
						<el-select v-model="filters4.nRoleId" placeholder="Select">
							<el-option v-for="item in totalRoleList" :key="item.nRoleId" v-if="item.nRoleId != 1" :label="item.sRoleName" :value="item.nRoleId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" v-on:click="change4">Search</el-button>
					</el-form-item>
				</el-form>
			</el-col>
			<el-col :span="24">
				<el-table ref="multipleTable" :data="tableData4" style="width: 100%">
					<el-table-column prop="sSchemaName" label="Schema"></el-table-column>
					<el-table-column prop="sSelectName" label="SelectName"></el-table-column>
					<el-table-column prop="valueStatus" label="valueStatus" :formatter="valueStatus"></el-table-column>
					<el-table-column prop="fieldStatus" label="fieldStatus" :formatter="fieldStatus"></el-table-column>
					<el-table-column label="Operation">
						<template slot-scope="scope">
							<el-button @click="changeDetail1(scope.row)" icon="el-icon-date"></el-button>
							<el-button @click="changeDetail2(scope.row)" icon="el-icon-edit-outline"></el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
			<el-dialog title="" :visible.sync="ViewFlag" width="80%">
				<span class="dialog-header" slot="title">
					<a style="font-size: 20px;margin-right: 30px;">Value Management</a> <el-button type="button" v-on:click="addView">Add+</el-button>
				</span>
				<div>
					<el-form :model="form" ref="form" label-width="160px">
						<el-form-item label="Column Name." prop="selectColumnList" v-for="(item, index) in ViewForm.list" :key="index">
							<el-select v-model="item.sColumnCode" placeholder="">
								<el-option v-for="item in ViewOptions" :key="item.sColumnCode" :label="item.sColumnName" :value="item.sColumnCode"></el-option>
							</el-select>
							<label>Value.</label>
							<el-input v-model="item.sColumnValue" style="width:220px;" placeholder=""></el-input>
							<el-button type="button" v-on:click="deleteView(index)">Delete-</el-button>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="ViewFlag = false">Cancel</el-button>
					<el-button type="primary" @click="saveViewFlag">Confirm</el-button>
				</span>
			</el-dialog>
			<el-dialog title=" Field Management" :visible.sync="ViewFieldFlag" width="80%">
				<div>

					<el-form :model="form" ref="form" label-width="160px">
						<div style="margin-bottom: 10px;">
							<el-checkbox border size="medium" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
						</div>
						<el-checkbox-group v-model="ViewFieldForm.list">

							<el-checkbox border size="medium" v-for="(item,index) in ViewOptions" :key="index" :label="item.sColumnCode" style="margin-bottom:10px;"></el-checkbox>
						</el-checkbox-group>
					</el-form>
				</div>
				<span slot="footer" class="dialog-footer">
						<el-button @click="ViewFieldFlag = false">Cancel</el-button>
						<el-button type="primary" @click="saveViewFieldFlag">Confirm</el-button>
					</span>
			</el-dialog>
		</el-tab-pane>
		<el-tab-pane label="Template Related" name="fivth">
			<el-row>
				<el-col :span="24">
					<el-form :inline="true" :model="filters5" label-width="100px">
						<el-form-item label="Role">
							<el-select v-model="filters5.nRoleId" placeholder="Select">
								<el-option v-for="item in totalRoleList" :key="item.nRoleId" v-if="item.nRoleId != 1" :label="item.sRoleName" :value="item.nRoleId"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" v-on:click="change5">Search</el-button>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="24">
					<el-transfer filterable :filter-method="filterMethod5" :titles="['Unselect', 'Select']" filter-placeholder="Name" v-model="filters5.nTemplateIds" :data="leftRoleList5"></el-transfer>
				</el-col>
				<el-col :span="24">
					<div style="margin-top:20px">
						<el-button @click="save5">Save</el-button>
					</div>
				</el-col>
			</el-row>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	import {
		getRoleInfoList,
		addRoleInfo,
		updateRoleInfo,
		addUserRole,
		getUserInfoByOppositeRoleList,
		getUserInfoByRoleList,
		addUserInfo,
		addDataBaseByRole,
		getSelectColumnList,
		getSelectByOppositeRoleList,
		getSelectByRoleList,
		addRoleAuthority,
		updateDetailRoleInfo,
		getRoleAuthorityList,
		selectRoleVisitAuthorityBynRoleId,
		selectRoleValueAuthorityBynSelectId,
		addRoleValueAuthority,
		addFieldAuthority,
		selectRoleFieldAuthorityBynSelectId,
		selectColumnValueBynSelectId,
		delFieldAuthority,
		getTemplateByOppsiteRoleList,
		getTemplateByRoleList,
		addRoleTemplate,
		delRoleValueAuthority
	} from '../../api/api.js';
	export default {
		data() {
			return {
				activeName: 'first',
				addRoleFlag: false,
				EditRoleFlag: false,
				checkAll: false,
				isIndeterminate: true,
				options: [{
						id: '1',
						name: 'Active'
					},
					{
						id: '0',
						name: 'Inactive'
					}
				],
				filters: {
					sRoleName: '',
					sState: '1',
					pageSize: 10,
					currentPage: 1
				},
				total: 0,
				form: {
					sRoleName: '',
					sRoleDescribe: '',
					roles: []
				},
				detailForm: {
					nRoleId: "",
					sRoleName: '',
					sRoleDescribe: '',
					roles: []
				},
				tableData: [],
				tableData3: [],
				tableData4: [],
				totalRoleList: [],
				filters2: {
					nRoleId: '',
					nUserIds: []
				},
				leftRoleList2: [],
				filters3: {
					nRoleId: '',
					nSelectIds: []
				},
				filters4: {
					nRoleId: '',
					pageSize: 10,
					currentPage: 1
				},
				filters5: {
					nRoleId: '',
					nTemplateIds: []
				},
				leftRoleList5: [],
				leftRoleList3: [],
				options3: [{
					id: "Admin",
					name: "Admin"
				}, {
					id: "Data",
					name: "Data"
				}, {
					id: "Upload",
					name: "Upload"
				}],
				options4: [{}],
				ViewFlag: false,
				ViewFieldFlag: false,
				ViewOptions: [],
				ViewFieldForm: {
					nRoleId: "",
					nSelectId: "",
					list: []
				},
				ViewForm: {
					nRoleId: "",
					nSelectId: "",
					list: [{
						sColumnCode: "",
						sColumnValue: ""
					}]
				}
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			handleCheckAllChange(flag) {
				if(flag == true) {
					var arr = [];
					for(var i = 0; i < this.ViewOptions.length; i++) {
						arr.push(this.ViewOptions[i]['sColumnCode']);
					}
					this.ViewFieldForm.list = arr;
				} else {
					this.ViewFieldForm.list = [];
				}
				this.isIndeterminate = false;
			},
			saveViewFlag() {
				var arr = [];
				this.ViewForm.list.forEach(one => {
					arr.push({
						nRoleId: this.ViewForm.nRoleId,
						nSelectId: this.ViewForm.nSelectId,
						sColumnCode: one.sColumnCode,
						sColumnValue: one.sColumnValue
					})
				})
				if(arr.length == 0) {
					delRoleValueAuthority({
						nRoleId: this.ViewForm.nRoleId,
						nSelectId: this.ViewForm.nSelectId
					}).then(res => {
						this.$message('Update Success');
						this.ViewFlag = false;
					})
				} else {
					addRoleValueAuthority(arr).then(res => {
						this.$message('Update Success');
						this.ViewFlag = false;
					});
				}
			},
			saveViewFieldFlag() {
				var arr = [];

				this.ViewFieldForm.list.forEach(one => {
					arr.push({
						nRoleId: this.ViewFieldForm.nRoleId,
						nSelectId: this.ViewFieldForm.nSelectId,
						sColumnCode: one
					})
				})
				if(arr.length == 0) {
					delFieldAuthority({
						nRoleId: this.ViewFieldForm.nRoleId,
						nSelectId: this.ViewFieldForm.nSelectId
					}).then(res => {
						this.$message('Update Success');
						this.ViewFieldFlag = false;
					})
				} else {
					addFieldAuthority(arr).then(res => {
						this.$message('Update Success');
						this.ViewFieldFlag = false;
					})
				}
			},
			addView() {
				this.ViewForm.list.push({
					sColumnCode: "",
					sColumnValue: ""
				});
			},
			deleteView(index) {
				this.ViewForm.list.splice(index, 1);
			},
			changeDetail1(data) {
				getSelectColumnList({
					currentPage: 1,
					nSelectId: data.nSelectId,
					pageSize: 9999
				}).then(res => {
					this.ViewOptions = res.data;
					selectRoleValueAuthorityBynSelectId({
						nSelectId: data.nSelectId,
						nRoleId: data.nRoleId
					}).then(res => {
						this.ViewForm.nSelectId = data.nSelectId;
						this.ViewForm.nRoleId = data.nRoleId;
						this.ViewForm.list = res.data;
						this.ViewFlag = true;
					});
				});
			},
			changeDetail2(data) {
				getSelectColumnList({
					currentPage: 1,
					nSelectId: data.nSelectId,
					pageSize: 9999
				}).then(res => {

					selectRoleFieldAuthorityBynSelectId({
						nSelectId: data.nSelectId,
						nRoleId: data.nRoleId
					}).then(res => {
						this.ViewFieldForm.nSelectId = data.nSelectId;
						this.ViewFieldForm.nRoleId = data.nRoleId;
						this.ViewOptions = res.data;
						var arr = [];
						res.data.forEach(one => {
							if(one.fieldStatus == 1) {
								arr.push(one.sColumnCode);
							}
						})
						this.ViewFieldForm.list = arr;
						this.ViewFieldFlag = true;
					});
				});
			},
			handleClick(tab, event) {
				this.queryInit();
			},
			toDetailRole(data) {
				getRoleAuthorityList({
					nRoleId: data.nRoleId
				}).then(res => {
					if(res.data.length == 0) {
						this.detailForm.nRoleId = data.nRoleId;
						this.detailForm.sRoleName = data.sRoleName
						this.detailForm.sRoleDescribe = data.sRoleDescribe
						this.detailForm.roles = []
						this.EditRoleFlag = true;
					} else {
						this.detailForm.nRoleId = data.nRoleId;
						this.detailForm.sRoleName = data.sRoleName
						this.detailForm.sRoleDescribe = data.sRoleDescribe
						this.detailForm.roles = res.data[0].sAuthority.split(',')
						this.EditRoleFlag = true;
					}
				})
			},
			saveEdit() {
				if(!this.detailForm.sRoleName) {
					this.$message.error('Please enter the role name');
					return;
				}
				if(!this.detailForm.sRoleDescribe) {
					this.$message.error('Please enter the role describe');
					return;
				}
				if(this.detailForm.roles.length == 0) {
					this.$message.error('Please select the Authority');
					return;
				}

				updateDetailRoleInfo({
					nRoleId: this.detailForm.nRoleId,
					sRoleDescribe: this.detailForm.sRoleDescribe,
					sRoleName: this.detailForm.sRoleName,
					sAuthority: this.detailForm.roles.join(',')
				}).then(res => {
					this.$refs.detailForm.resetFields();
					this.reGetList();
					this.$message('Update Success');
					this.EditRoleFlag = false;
				});
			},
			queryInit: function() {
				getRoleInfoList({
					pageSize: 9999,
					sState: "1",
					currentPage: 1
				}).then(res => {
					this.totalRoleList = res.data;
				});
			},
			change2() {
				if(!!this.filters2.nRoleId) {
					getUserInfoByOppositeRoleList({
						pageSize: 9999,
						nRoleId: this.filters2.nRoleId,
						currentPage: 1
					}).then(res => {
						var arr = [];
						for(var i = 0; i < res.data.length; i++) {
							arr.push({
								key: res.data[i]['nUserId'],
								label: res.data[i]['sName']
							});
						}
						getUserInfoByRoleList({
							pageSize: 9999,
							nRoleId: this.filters2.nRoleId,
							currentPage: 1
						}).then(res2 => {
							var _arr = [];
							for(var i = 0; i < res2.data.length; i++) {
								arr.push({
									key: res2.data[i]['nUserId'],
									label: res2.data[i]['sName']
								});
								_arr.push(res2.data[i]['nUserId']);
							}
							this.filters2.nUserIds = _arr;
							this.leftRoleList2 = arr;
						});
					});
				}
			},
			change5() {
				if(!!this.filters5.nRoleId) {
					getTemplateByOppsiteRoleList({
						pageSize: 9999,
						nRoleId: this.filters5.nRoleId,
						currentPage: 1
					}).then(res => {
						var arr = [];
						for(var i = 0; i < res.data.length; i++) {
							arr.push({
								key: res.data[i]['nTemplateId'],
								label: res.data[i]['sTemplateName']
							});
						}
						getTemplateByRoleList({
							pageSize: 9999,
							nRoleId: this.filters5.nRoleId,
							currentPage: 1
						}).then(res2 => {
							var _arr = [];
							for(var i = 0; i < res2.data.length; i++) {
								arr.push({
									key: res2.data[i]['nTemplateId'],
									label: res2.data[i]['sTemplateName']
								});
								_arr.push(res2.data[i]['nTemplateId']);
							}
							this.filters5.nTemplateIds = _arr;
							this.leftRoleList5 = arr;
						});
					});
				}
			},
			change3() {
				if(!!this.filters3.nRoleId) {
					getSelectByOppositeRoleList({
						pageSize: 9999,
						nRoleId: this.filters3.nRoleId,
						currentPage: 1
					}).then(res => {
						var arr = [];
						for(var i = 0; i < res.data.length; i++) {
							arr.push({
								key: res.data[i]['nSelectId'],
								label: res.data[i]['sSchemaSelectName']
							});
						}
						getSelectByRoleList({
							pageSize: 9999,
							nRoleId: this.filters3.nRoleId,
							currentPage: 1
						}).then(res2 => {
							var _arr = [];
							for(var i = 0; i < res2.data.length; i++) {
								arr.push({
									key: res2.data[i]['nSelectId'],
									label: res2.data[i]['sSchemaSelectName']
								});
								_arr.push(res2.data[i]['nSelectId']);
							}
							this.filters3.nSelectIds = _arr;
							this.leftRoleList3 = arr;
						});
					});
				}
			},
			save2() {
				//			for (var i = 0; i < this.filters2.nUserIds.length; i++) {
				//				addUserRole({
				//					nRoleId: this.filters2.nRoleId,
				//					nUserId: this.filters2.nUserIds[i]
				//				});
				//			}
				//			this.$message('Save Success');
				addUserRole(this.filters2).then(res => {
					this.$message("Save Success");
				});
			},
			save3() {
				//			for (var i = 0; i < this.filters3.nSelectIds.length; i++) {
				//				addDataBaseByRole({
				//					nRoleId: this.filters3.nRoleId,
				//					nSelectId: this.filters3.nSelectIds[i]
				//				});
				//			}
				//			this.$message('Save Success');

				addDataBaseByRole(this.filters3).then(res => {
					this.$message("Save Success");
				});
			},
			save5() {
				//			for (var i = 0; i < this.filters3.nSelectIds.length; i++) {
				//				addDataBaseByRole({
				//					nRoleId: this.filters3.nRoleId,
				//					nSelectId: this.filters3.nSelectIds[i]
				//				});
				//			}
				//			this.$message('Save Success');

				addRoleTemplate(this.filters5).then(res => {
					this.$message("Save Success");
				});
			},
			filterMethod2(query, item) {
				return item.label.indexOf(query) > -1;
			},
			filterMethod3(query, item) {
				return item.label.indexOf(query) > -1;
			},
			filterMethod5(query, item) {
				return item.label.indexOf(query) > -1;
			},
			sState(data) {
				for(var i = 0; i < this.options.length; i++) {
					if(this.options[i]['id'] == data.sState) {
						return this.options[i]['name'];
					}
				}
			},
			valueStatus(data) {
				var arr = [];
				if(data.valueStatus == 0) {
					arr.push('Value Unmanaged');
				} else if(data.valueStatus > 0) {
					arr.push('Value Managed');
				}
				return arr.join('\n\r');
			},
			fieldStatus(data) {
				var arr = [];
				if(data.fieldStatus == 0) {
					arr.push('Field  Unmanaged');
				} else if(data.fieldStatus > 0) {
					arr.push('Field  Managed');
				}
				return arr.join('\n\r');
			},
			toggleSelection(sState) {
				var arr = [];
				for(var i = 0; i < this.tableData3.length; i++) {
					arr.push(this.tableData3[i]['nRoleId']);
				}
				var _this = this;
				this.$confirm('Confirm to ' + (sState == 1 ? 'Active' : 'Inactive') + '?', 'Tips', {
						type: 'warning',
						customClass: 'customConfimClass'
					})
					.then(() => {
						updateRoleInfo({
							nRoleIds: arr,
							sState: sState
						}).then(res => {
							_this.reGetList();
						});
					})
					.catch(() => {});
			},
			save() {
				if(!this.form.sRoleName) {
					this.$message.error('Please enter the role name');
					return;
				}
				if(!this.form.sRoleDescribe) {
					this.$message.error('Please enter the role describe');
					return;
				}
				if(this.form.roles.length == 0) {
					this.$message.error('Please select the Authority');
					return;
				}

				addRoleInfo({
					sRoleDescribe: this.form.sRoleDescribe,
					sRoleName: this.form.sRoleName,
					sAuthority: this.form.roles.join(',')
				}).then(res => {
					this.$refs.form.resetFields();
					this.reGetList();
					this.$message('Add Success');
					this.addRoleFlag = false;
					//					addRoleAuthority({
					//						nRoleId: res.data.nRoleId,
					//						sAuthority: this.form.roles.join(',')
					//					}).then(res => {
					//						this.$refs.form.resetFields();
					//						this.reGetList();
					//						this.$message('Add Success');
					//						this.addRoleFlag = false;
					//					});
				});
			},
			handleSelectionChange(val) {
				this.tableData3 = val;
			},
			handleCurrentChange(page) {
				this.filters.currentPage = page;
				this.getList();
			},
			reGetList() {
				this.filters.currentPage = 1;
				this.getList();
			},
			change4() {
				this.filters4.currentPage = 1;
				var param2 = Object.assign({}, this.filters4);
				selectRoleVisitAuthorityBynRoleId(param2).then(res => {
					this.tableData4 = res.data;
				});
			},
			getList() {
				var param = Object.assign({}, this.filters);
				getRoleInfoList(param).then(res => {
					this.tableData = res.data;
					this.total = res.page.totalCount * 1;
				});
				//this.change4();
			}
		}
	};
</script>

<style></style>


// WEBPACK FOOTER //
// role.vue?499dc410